import { Stack, Typography } from '@mui/material';
import { type FC } from 'react';

const SummaryStat: FC<{ label: string; value: string; emphasised?: boolean }> = ({
  label,
  value,
  emphasised,
}) => (
  <Stack sx={{ minWidth: 120 }}>
    <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: 0.5 }}>
      {label}
    </Typography>
    <Typography variant={emphasised ? 'h5' : 'h6'} sx={{ fontWeight: emphasised ? 700 : 500 }}>
      {value}
    </Typography>
  </Stack>
);

export default SummaryStat;
